import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import OrgUserList from '~/apps/shared/containers/users/OrgUserList';


export default function() {
  return (
    <CurrentOrgInjector
      component={OrgUserList}
      onEdit={(userId) => navigate('receiver.admin.settings.team.edit', {userId})}
    />
  );
}
